import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  & > ", " {\n    margin-bottom: 16px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  margin: 0 0 ", ";\n  line-height: 1.5;\n  color: ", ";\n  font-size: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  margin: 8px 0;\n  line-height: 1.5;\n  color: ", ";\n  font-size: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 0 16px;\n  flex: 1 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { List } from '../group/Group';

var ellipsisByLinesCss = function ellipsisByLinesCss(lines) {
  return css(_templateObject(), lines);
};

var MetaContent = styled.div(_templateObject2());
var Title = styled.h3(_templateObject3(), ellipsisByLinesCss(themeGet('card.title.lineClamp')), themeGet('card.title.color'), themeGet('card.title.fontSize'));
var Description = styled.p(_templateObject4(), function (props) {
  return ellipsisByLinesCss(props.lineClamp || themeGet('card.description.lineClamp'));
}, themeGet('card.description.marginBottom'), themeGet('card.description.color'), themeGet('card.description.fontSize'));
var Content = styled.div(_templateObject5(), List);
export var Meta = function Meta(_ref) {
  var title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      descriptionLineClamp = _ref.descriptionLineClamp,
      rest = _objectWithoutProperties(_ref, ["title", "description", "children", "descriptionLineClamp"]);

  return (
    /*#__PURE__*/
    React.createElement(MetaContent, rest,
    /*#__PURE__*/
    React.createElement("div", null, title &&
    /*#__PURE__*/
    React.createElement(Title, null, title), description &&
    /*#__PURE__*/
    React.createElement(Description, {
      lineClamp: descriptionLineClamp
    }, description)),
    /*#__PURE__*/
    React.createElement(Content, null, children))
  );
};